module.exports = __webpack_public_path__ + "img/EmojiPeopleOutlined.aaaa4343.svg";